import { render } from "./CreateContactGuide.vue?vue&type=template&id=4bc75146&scoped=true"
import script from "./CreateContactGuide.vue?vue&type=script&lang=js"
export * from "./CreateContactGuide.vue?vue&type=script&lang=js"

import "./CreateContactGuide.vue?vue&type=style&index=0&id=4bc75146&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc75146"]])

export default __exports__